import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import AssigneeFilter from '@atlassian/jira-filters/src/ui/filters/assignee/main.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useTableFilterStore } from '../../../controllers/top-filter';
import { useAllKnownAssignees } from './utils';

const AssigneesFilter = ({ maxVisibleUsers = 5 }: { maxVisibleUsers?: number }) => {
	const [{ assignees: selectedUsers }, { toggleAssignee }] = useTableFilterStore();
	const assignees = useAllKnownAssignees();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return assignees.length > 0 ? (
		<ListFilterContainer>
			{/* @ts-expect-error - TS2739 - Type '{ users: Person[]; maxUsers: number; selectedUsers: string[]; onToggle: (assignee: string) => void | Promise<void>; }' is missing the following properties from type '{ isAddPeopleButtonEnabled: boolean; readonly projectId: number; }': isAddPeopleButtonEnabled, projectId */}
			<AssigneeFilter
				users={assignees}
				maxUsers={maxVisibleUsers}
				selectedUsers={selectedUsers}
				onToggle={(assignee) => {
					fireUIAnalytics(
						createAnalyticsEvent({
							action: 'toggled',
							actionSubject: 'deploymentsAssigneePicker',
						}),
					);
					return toggleAssignee(assignee);
				}}
			/>
		</ListFilterContainer>
	) : null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ListFilterContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:not(:empty)': {
		display: 'flex',
		marginRight: 0,
		paddingRight: token('space.200', '16px'),
		position: 'relative',
		'&::after': {
			content: "''",
			position: 'absolute',
			top: '50%',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			height: `${gridSize * 2}px`,
			transform: 'translateY(-50%)',
			width: '1px',
			right: 0,
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			background: token('color.background.neutral', colors.N40),
		},
	},
});

export default AssigneesFilter;
